export default __webpack_public_path__ + "static/media/logout.ea298ed7.svg";